export const DSIHtml = ({value, as, ...props}) => {
  let Tag = as || 'span'
  return <Tag dangerouslySetInnerHTML={{__html: value}} {...props} />
}
